module.exports = __webpack_public_path__ + "img/12.f56f006.png";